export default "__VITE_ASSET__9RJNHoS5__"